module.exports = __webpack_public_path__ + "static/media/stahls.9f81b27c.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/stahls.png
// module id = 1503
// module chunks = 0